<template>
    <div>
        <v-app id="inspire" :style="{ background: $vuetify.theme.themes.dark.background }">
            <v-container>
                <v-row justify="center" class="space">
                    <v-col cols="12" md="2">
                        <v-card :color="'white'" class="d-flex align-center rounded-xl" dark height="150">
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-list-item three-line class="mt-6">
                                        <v-list-item-content>
                                            <div class="mb-4">
                                                <v-skeleton-loader v-if="load" type="circle"
                                                    class="ma-auto"></v-skeleton-loader>
                                                <v-icon v-else x-large :color="'#2196F3'">mdi-notebook-outline</v-icon>
                                                <!-- Cor azul para o ícone de consultas -->
                                            </div>
                                            <v-list-item-subtitle :class="'black--text'">Consultas
                                                realizadas</v-list-item-subtitle>
                                            <v-list-item-title class="headline mb-1" :class="'black--text'">
                                                <strong>{{ qtdConsultasFinalizada }}</strong>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-card :color="'white'" class="d-flex align-center rounded-xl" dark height="150">
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-list-item three-line class="mt-6">
                                        <v-list-item-content>
                                            <div class="mb-4">
                                                <v-skeleton-loader v-if="load" type="circle"
                                                    class="ma-auto"></v-skeleton-loader>
                                                <v-icon v-else x-large :color="'primary'">fas fa-user-md</v-icon>
                                                <!-- Cor verde para o ícone de pacientes -->
                                            </div>
                                            <v-list-item-subtitle :class="'black--text'">Pacientes
                                                Atendidos</v-list-item-subtitle>
                                            <v-list-item-title class="headline mb-1" :class="'black--text'">
                                                <strong>{{ qtdPacientesAtendidos }}</strong>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-card :color="'white'" class="d-flex align-center rounded-xl" dark height="150">
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-list-item three-line class="mt-6">
                                        <v-list-item-content>
                                            <div class="mb-4">
                                                <v-skeleton-loader v-if="load" type="circle"
                                                    class="ma-auto"></v-skeleton-loader>
                                                <v-icon v-else x-large :color="'red'">fas fa-pills</v-icon>
                                                <!-- Cor vermelha para o ícone de medicamentos -->
                                            </div>
                                            <v-list-item-subtitle :class="'black--text'">Medicamentos
                                                Prescritos</v-list-item-subtitle>
                                            <v-list-item-title class="headline mb-1" :class="'black--text'">
                                                <strong>{{ qtdReceitasPrescritas }}</strong>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-card :color="'white'" class="d-flex align-center rounded-xl" dark height="150">
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-list-item three-line class="mt-6">
                                        <v-list-item-content>
                                            <div class="mb-4">
                                                <v-skeleton-loader v-if="load" type="circle"
                                                    class="ma-auto"></v-skeleton-loader>
                                                <v-icon v-else x-large :color="'orange'">mdi-flask-outline</v-icon>
                                                <!-- Cor laranja para o ícone de exames -->
                                            </div>
                                            <v-list-item-subtitle :class="'black--text'">Exames
                                                Solicitados</v-list-item-subtitle>
                                            <v-list-item-title class="headline mb-1" :class="'black--text'">
                                                <strong>{{ qtdExamesSolicitados }}</strong>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                </v-row>
                <v-row class="mt-n12">
                    <v-col cols="12" sm="12">
                        <v-card class="pa-4 mt-8" outlined>
                            <apexchart ref="apexChart" type="line" height="350" :options="chartOptions"
                                :series="series"></apexchart>
                        </v-card>
                    </v-col>
                </v-row>
                <v-toolbar color="rgba(0,0,0,0)" flat class="mt-4">
                    <v-toolbar-title>Equipe Médica</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card class="rounded-lg pa-1" outlined height="25vh" style="overflow-y: auto;">
                    <v-row>
                        <v-col cols="12" sm="3" v-for="medico in equipe" :key="medico.nome">
                            <v-list subheader two-line>
                                <v-list-item>
                                    <v-badge bordered bottom color="primary" dot offset-x="28" offset-y="22">
                                        <v-list-item-avatar>
                                            <v-avatar size="40">
                                                <v-img> <v-icon color="grey" large>person</v-icon></v-img>
                                            </v-avatar>
                                        </v-list-item-avatar>
                                    </v-badge>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ medico.nomeMedico }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ medico.nomeEspecialidade }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card>
            </v-container>
        </v-app>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import medicoService from '../../services/medico.service'

export default {
  name: 'HomePage',

  data: () => ({
    user: null,
    load: false,
    qtdConsultasFinalizada: 0,
    qtdPacientesAtendidos: 0,
    qtdReceitasPrescritas: 0,
    qtdExamesSolicitados: 0,
    toggle_exclusive: 1,
    consultas: [
    ],
    equipe: [],
    series: [
      {
        name: 'Consultas Realizadas',
        type: 'column',
        data: [] // Receberá os valores de `quantidadeConsultas`
      },
      {
        name: 'Tempo Médio de Atendimento (minutos)',
        type: 'line',
        data: [] // Receberá os valores de `mediaTempoAtendimentoMinutos`
      }
    ],
    chartOptions: {
      chart: {
        height: 350,
        type: 'line'
      },
      stroke: {
        width: [0, 4]
      },
      title: {
        text: 'Métrica Mensal'
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1]
      },
      labels: [], // Será preenchido com os dias da semana
      colors: [
        '#3F51B5',
        '#7CB342'
      ],
      yaxis: [
        {
          title: {
            text: 'Consultas Realizadas'
          },
          labels: {
            formatter: value => Math.min(value, 999) // Limita a 999
          }
        },
        {
          opposite: true,
          title: {
            text: 'Tempo Médio de Atendimento (minutos)'
          },
          labels: {
            formatter: value => Math.min(value, 999) // Limita a 999
          }
        }
      ]
    }

  }),
  methods: {
    // Método para buscar métricas e atualizar o gráfico
    metricasAtendimento () {
      this.load = true
      medicoService.medico.metricasAtendimento(this.user.id, this.user.idUnidade)
        .then(r => {
          if (r.status == 200) {
            var dados = r.data.mediaAtendimentoDaSemana
            this.qtdConsultasFinalizada = r.data.qtdConsultasFinalizada.quantidadeConsultasFinalizadas
            this.qtdPacientesAtendidos = r.data.qtdPacientesAtendidos.quantidadePacientes
            this.qtdReceitasPrescritas = r.data.qtdReceitasPrescritas.quantidadeReceitas
            this.qtdExamesSolicitados = r.data.qtdExamesSolicitados.totalExamesSolicitados

            // Dados para o gráfico
            const consultas = []
            const tempos = []
            const labels = []
            console.log(dados)

            dados.forEach(item => {
              consultas.push(item.quantidadeConsultas)
              tempos.push(item.mediaTempoAtendimentoMinutos || 0) // Substituir null por 0
              labels.push(`${this.getDayName(new Date(item.dia))} (${new Date(item.dia).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })})`) // Converter data para o nome do dia
            })

            // Atualizar as séries e os labels
            this.series[0].data = consultas
            this.series[1].data = tempos
            this.chartOptions.labels = labels

            this.$refs.apexChart.updateSeries(this.series)
            this.$refs.apexChart.updateOptions({ labels })
          }
        })
        .finally(() => {
          this.load = false
        })
    },

    listarEquipeMedica () {
      medicoService.medico.listarEquipeMedica(this.user.idUnidade).then(r => {
        if (r.status == 200) {
          this.equipe = r.data
        }
      })
    },

    // Método para obter o nome do dia
    getDayName (date) {
      const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
      return days[date.getDay()]
    },
    logout () {
      console.log('em logout..')
      // this.$router.push("/login");
      this.$store
        .dispatch('FedLogOut')
        .then(rsp => {
          this.$router.push('/login')
        }).catch(error => {
          // this.progress = false;
          // this.alert = true;
          // this.msg = error;
        })
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.metricasAtendimento()
    this.listarEquipeMedica()
  }
}
</script>

<style>
.space {
    margin-left: -100px;
    margin-right: -100px;
}
</style>
